export const DEFAULT_OPTIONS = [
    {
        label: "Strongly Agree",
        value: 5
    },
    {
        label: "Agree",
        value: 4
    },
    {
        label: "Neither Agree nor Disagree",
        value: 3
    },
    {
        label: "Disagree",
        value: 2
    },
    {
        label: "Strongly Disagree",
        value: 1
    }
];

export const dssQuestions_EN = [
    {
        question: "Employees at our workplace are not exposed bullying.",
        description:
            "Bullying takes place when a person repeatedly and over an extended period of time is exposed to unpleasant or degrading treatment. For bullying to take place the person who is bullied must find it difficult to defend themselves. Bullying can be verbal, psychological, social, or physical, and is intended to intimidate, degrade, or undermine.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace are not exposed to violence or threats.",
        description:
            "Workplace violence refers to any act of physical aggression, verbal abuse, harassment, or intimidation that causes harm. Workplace threats involve any statement, behavior, or action—explicit or implied that suggests intent to cause harm.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace are recognized and appreciated.",
        description:
            "Rewards in the workplace refers to an employee's perception that the compensation, recognition, or benefits they receive are match their efforts, contributions, or expectations.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace are treated fairly.",
        description:
            "Fairness in the workplace refers to fair and respectful treatment by supervisors’ colleagues.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "The decision-making processes at our workplace usually involve those who will be affected.",
        description:
            "Fair decision making processes mean that the process includes and involves the employees who are affected.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace support each other.",
        description:
            "Support from colleagues can be things like practical and emotional help, advice and guidance.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Supervisors at our workplace are supportive.",
        description:
            "Support from supervisor can be practical help, advice and guidance, as well as talking through difficulties at work.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace have enough time to complete their work tasks.",
        description:
            "Suitable job demands refers to having enough time to complete work tasks without consistently excessive workload, tight deadlines, complex tasks, high emotional strain, or intense cognitive demands.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace are not exposed to emotionally demanding situations.",
        description:
            "Emotionally demanding situations refers to stressful interactions, such as managing conflict with customers or clients, or consistently displaying emotions that may not align with one’s true feelings in the workplace.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace are able to influence how they carry out their work tasks.",
        description:
            "Job control refers to influence over work tasks such as pace, how to perform duties.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace do not regularly lift weights exceeding 5 kg as part of their tasks.",
        description:
            "We would like you to assess if (some) employees at your workplace regularly need to lift weights exceeding 5 kg as part of work tasks. By regularly we mean several times per hour .",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace are frequently required to bend forward or twist their upper body during their work tasks.",
        description:
            "We would like to assess whether (some) employees at your workplace regularly adopt awkward postures. With regularly we mean more than 4 hours per workday",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace drive a car or vehicle for a significant part of the workday.",
        description:
            "We would like to assess whether (some) employees at your workplace are exposed to whole-body vibration during their regular work. With exposure to whole-body vibration we mean at least 4 hours per work day as driver of cars or trucks or operator of vehicles, such as earth-moving vehicles\n\n",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question: "Employees at our workplace sit prolonged periods during their regular workday.",
        description:
            "We would like to assess whether (some) employees at your workplace spend more than 4 hours of sitting per work day",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace are required to work with their arms above shoulder height frequently.",
        description:
            "We would like to assess whether (some) employees at your workplace spend more than 4 hours working with their hands above shoulder height",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Tasks at our workplace involve employees applying significant force with their hands and arms.",
        description:
            "We would like to assess whether (some) employees at your workplace need to use force, equivalent to lifting 5 kg, more than 2 hours per work day.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace perform tasks that require repetitive movements of their hands or arms many times per minute.",
        description:
            "We would like to assess whether (some) employees at your workplace use the same motion with little or no variation very few seconds for more than 2 hours per work day.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    },
    {
        question:
            "Employees at our workplace use vibrating hand tools as part of their regular work activities.",
        description:
            "We would like to assess whether (some) employees at your workplace use vibrating hand tools for more than 2 hours per work day.",
        options: [
            {
                label: "Strongly Agree",
                value: 5
            },
            {
                label: "Agree",
                value: 4
            },
            {
                label: "Neither Agree nor Disagree",
                value: 3
            },
            {
                label: "Disagree",
                value: 2
            },
            {
                label: "Strongly Disagree",
                value: 1
            }
        ]
    }
];

export const dssQuestions_SQ = [
    {
        question: "Punonjësit në vendin tonë të punës nuk janë të ekspozuar ndaj ngacmimeve.",
        description:
            "Ngacmimi ndodh kur një person përsëritet dhe gjatë një periudhe të gjatë kohe ekspozohet ndaj trajtimeve të pakëndshme ose poshtëruese. Për të ekzistuar ngacmimi, personi që ngacmohet duhet ta ketë të vështirë të mbrojë veten. Ngacmimi mund të jetë verbal, psikologjik, social ose fizik dhe synon të intimidrojë, poshtërojë ose minojë dikë.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës nuk janë të ekspozuar ndaj dhunës ose kërcënimeve.",
        description:
            "Dhunë në vendin e punës i referohet çdo akti agresioni fizik, abuzimi verbal, ngacmimi ose intimidimi që shkakton dëm. Kërcënimet përfshijnë çdo deklaratë, sjellje ose veprim, qoftë i shprehur apo i nënkuptuar, që sugjeron qëllim për të shkaktuar dëm.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question: "Punonjësit në vendin tonë të punës njihen dhe vlerësohen.",
        description:
            "Shpërblimet në punë i referohen perceptimit të punonjësit se kompensimi, njohja ose përfitimet që merr janë në përputhje me përpjekjet, kontributet ose pritshmëritë e tij.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question: "Punonjësit në vendin tonë të punës trajtohen drejtësisht.",
        description:
            "Drejtësia në vendin e punës i referohet trajtimit të drejtë dhe me respekt nga mbikëqyrësit dhe kolegët.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Proceset e vendimmarrjes në vendin tonë të punës zakonisht përfshijnë ata që do të preken.",
        description:
            "Proceset e drejta të vendimmarrjes do të thotë që në to përfshihen punonjësit që ndikohen nga vendimet.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question: "Punonjësit në vendin tonë të punës mbështesin njëri-tjetrin.",
        description:
            "Mbështetja nga kolegët mund të përfshijë ndihmë praktike dhe emocionale, këshilla dhe udhëzime.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question: "Mbikëqyrësit në vendin tonë të punës janë mbështetës.",
        description:
            "Mbështetja nga mbikëqyrësi mund të përfshijë ndihmë praktike, këshilla, udhëzim dhe diskutime mbi vështirësitë në punë.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës kanë mjaftueshëm kohë për të përfunduar detyrat e tyre.",
        description:
            "Kërkesat e përshtatshme të punës i referohen kohës së mjaftueshme për detyra pa ngarkesë të tepruar, afate të ngushta, detyra komplekse, tension emocional ose kërkesa të larta kognitive.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës nuk janë të ekspozuar ndaj situatave emocionalisht kërkuese.",
        description:
            "Situata emocionalisht kërkuese nënkupton ndërveprime stresuese, si menaxhimi i konflikteve me klientët, ose shfaqja e vazhdueshme e emocioneve që nuk përputhen me ndjenjat e brendshme.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës kanë ndikim në mënyrën se si kryejnë detyrat e tyre.",
        description:
            "Kontrolli në punë nënkupton ndikimin mbi detyrat, si ritmi dhe mënyra e kryerjes së tyre.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës nuk e ngarkojnë rregullisht trupin me pesha mbi 5 kg si pjesë të detyrave të tyre.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës në vendin tuaj të punës ngarkohen rregullisht me pesha mbi 5 kg disa herë në orë si pjesë e detyrave.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës kërkohet të përkulen përpara ose të rrotullojnë trupin e sipërm rregullisht gjatë detyrave.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës në vendin tuaj të punës adoptojnë postura të vështira për më shumë se 4 orë në ditë pune.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës vozisin makinë ose mjet për një pjesë të konsiderueshme të ditës së punës.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës ekspozohen ndaj dridhjeve të trupit të tërë për të paktën 4 orë në ditë pune si drejtues makinash, kamionësh ose operatorë të mjetesh, si mjetet tokërrënuese.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës ulen për periudha të gjata gjatë ditës së punës.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës kalojnë më shumë se 4 orë duke u ulur në ditë pune.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës kërkohet të punojnë me duar mbi nivelin e supeve shpesh.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës kalojnë më shumë se 4 orë duke punuar me duar mbi nivelin e supeve.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Detyrat në vendin tonë të punës përfshijnë përdorimin e forcës së konsiderueshme me duar dhe krahë.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës duhet të përdorin forcë ekuivalente me ngritjen e 5 kg për më shumë se 2 orë në ditë pune.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës kryejnë detyra që kërkojnë lëvizje të përsëritura të duarve ose krahëve shumë herë në minutë.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës përdorin të njëjtën lëvizje pa shumë ndryshim çdo disa sekonda për më shumë se 2 orë në ditë pune.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    },
    {
        question:
            "Punonjësit në vendin tonë të punës përdorin mjete dridhëse me dorë si pjesë e aktiviteteve të tyre të rregullta.",
        description:
            "Ju lutemi vlerësoni nëse disa punonjës përdorin mjete dridhëse me dorë për më shumë se 2 orë në ditë pune.",
        options: [
            { label: "Plotësisht Pajtohem", value: 5 },
            { label: "Pajtohem", value: 4 },
            { label: "As Pajtohem, As Kundërshtoj", value: 3 },
            { label: "Nuk Pajtohem", value: 2 },
            { label: "Aspak Pajtohem", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// Traduções para cada idioma: Húngaro (HU), Português (PT), Espanhol (ES),
// Alemão (DE), Turco (TR), Holandês (NL) e Dinamarquês (DA).
////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////
// 1. PORTUGUÊS (Portugal) - pt
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_PT = [
    {
        question: "Os trabalhadores no nosso local de trabalho não são alvo de assédio.",
        description:
            "O assédio ocorre quando uma pessoa é repetidamente e durante um período prolongado sujeita a um tratamento desagradável ou degradante. Para que haja assédio, a pessoa assediada deve ter dificuldade em defender-se. O assédio pode ser verbal, psicológico, social ou físico, e destina-se a intimidar, rebaixar ou minar a pessoa visada.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho não são expostos a violência ou ameaças.",
        description:
            "A violência no local de trabalho refere-se a qualquer ato de agressão física, abuso verbal, assédio ou intimidação que cause dano. As ameaças no local de trabalho incluem qualquer declaração, comportamento ou ação — explícita ou implícita — que sugira a intenção de causar dano.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question: "Os trabalhadores no nosso local de trabalho são reconhecidos e valorizados.",
        description:
            "Recompensas no local de trabalho referem-se à perceção do trabalhador de que a compensação, o reconhecimento ou os benefícios que recebe correspondem ao seu esforço, contribuições ou expectativas.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question: "Os trabalhadores no nosso local de trabalho são tratados de forma justa.",
        description:
            "Equidade no local de trabalho refere-se a um tratamento justo e respeitoso por parte dos supervisores e colegas.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os processos de tomada de decisão no nosso local de trabalho geralmente envolvem aqueles que serão afetados.",
        description:
            "Processos de tomada de decisão justos significam que o processo inclui e envolve os trabalhadores que são afetados.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question: "Os trabalhadores no nosso local de trabalho apoiam-se mutuamente.",
        description:
            "O apoio dos colegas pode incluir ajuda prática e emocional, conselhos e orientação.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question: "Os supervisores no nosso local de trabalho são prestáveis.",
        description:
            "O apoio do supervisor pode incluir ajuda prática, conselhos e orientação, bem como discutir dificuldades no trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho têm tempo suficiente para concluir as suas tarefas.",
        description:
            "Exigências de trabalho adequadas referem-se a ter tempo suficiente para concluir as tarefas sem carga de trabalho consistentemente excessiva, prazos muito apertados, tarefas complexas, elevada pressão emocional ou exigências cognitivas intensas.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho não são expostos a situações emocionalmente exigentes.",
        description:
            "Situações emocionalmente exigentes referem-se a interações stressantes, tais como gerir conflitos com clientes ou utilizadores, ou exibir constantemente emoções que possam não corresponder aos sentimentos reais no local de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho conseguem influenciar a forma como executam as suas tarefas.",
        description:
            "O controlo do trabalho refere-se à influência sobre as tarefas, como o ritmo e a forma de realizar as funções.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho não levantam regularmente pesos superiores a 5 kg como parte das suas tarefas.",
        description:
            "Gostaríamos que avaliasse se (alguns) trabalhadores no seu local de trabalho precisam regularmente de levantar pesos superiores a 5 kg como parte das tarefas. Por regularmente, entendemos várias vezes por hora.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho precisam frequentemente de se inclinar para a frente ou torcer a parte superior do corpo durante as suas tarefas.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho adotam posturas incómodas com frequência. Por frequência, entendemos mais de 4 horas por dia de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho conduzem um carro ou outro veículo durante grande parte do dia de trabalho.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho estão expostos a vibrações de corpo inteiro durante o seu trabalho. Por exposição a vibrações de corpo inteiro entendemos pelo menos 4 horas por dia de trabalho a conduzir carros ou camiões ou a operar veículos, como máquinas de terraplanagem.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho permanecem sentados por longos períodos durante o seu dia de trabalho.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho passam mais de 4 horas sentados por dia de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho precisam frequentemente de trabalhar com os braços acima da altura dos ombros.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho passam mais de 4 horas a trabalhar com as mãos acima da altura dos ombros.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "As tarefas no nosso local de trabalho envolvem os trabalhadores a aplicar força significativa com as mãos e braços.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho precisam de exercer força equivalente a levantar 5 kg, durante mais de 2 horas por dia de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho executam tarefas que exigem movimentos repetitivos das mãos ou dos braços muitas vezes por minuto.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho fazem o mesmo movimento com pouca ou nenhuma variação a cada poucos segundos, durante mais de 2 horas por dia de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    },
    {
        question:
            "Os trabalhadores no nosso local de trabalho utilizam ferramentas manuais vibratórias como parte das suas atividades regulares de trabalho.",
        description:
            "Gostaríamos de avaliar se (alguns) trabalhadores no seu local de trabalho utilizam ferramentas manuais vibratórias durante mais de 2 horas por dia de trabalho.",
        options: [
            { label: "Concordo totalmente", value: 5 },
            { label: "Concordo", value: 4 },
            { label: "Nem concordo nem discordo", value: 3 },
            { label: "Discordo", value: 2 },
            { label: "Discordo totalmente", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 2. HÚNGARO (Hungary) - hu
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_HU = [
    {
        question: "A munkahelyünkön dolgozó munkavállalók nincsenek kitéve zaklatásnak.",
        description:
            "A zaklatás akkor fordul elő, amikor valakit ismétlődően és hosszabb időn keresztül kellemetlen vagy megalázó bánásmód ér. A zaklatáshoz hozzátartozik, hogy a zaklatott személy nehezen tudja megvédeni magát. A zaklatás lehet verbális, pszichológiai, társadalmi vagy fizikai, és célja a megfélemlítés, megalázás vagy aláásás.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók nincsenek kitéve erőszaknak vagy fenyegetéseknek.",
        description:
            "A munkahelyi erőszak minden olyan fizikai agressziót, verbális bántalmazást, zaklatást vagy megfélemlítést jelent, amely kárt okoz. A munkahelyi fenyegetés minden olyan kijelentést, viselkedést vagy cselekedetet magában foglal – nyíltan vagy burkoltan –, amely károkozási szándékot sugall.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question: "A munkahelyünkön dolgozó munkavállalókat elismerik és megbecsülik.",
        description:
            "A munkahelyi jutalmazás arra utal, hogy a munkavállaló úgy érzi, a kompenzáció, elismerés vagy juttatások összhangban állnak az erőfeszítéseivel, hozzájárulásaival vagy elvárásaival.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question: "A munkahelyünkön dolgozó munkavállalókat igazságosan kezelik.",
        description:
            "Az igazságosság a munkahelyen azt jelenti, hogy a felügyelők és kollégák tisztességesen és tisztelettel bánnak velük.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön a döntéshozatali folyamatok általában bevonják azokat, akiket az adott döntés érint.",
        description:
            "Az igazságos döntéshozatali folyamatok azt jelentik, hogy a folyamatba bevonják és részvételt biztosítanak azoknak a munkavállalóknak, akiket az érint.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question: "A munkahelyünkön dolgozó munkavállalók támogatják egymást.",
        description:
            "A kollégák általi támogatás magában foglalhat gyakorlati és érzelmi segítséget, tanácsot és útmutatást.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question: "A munkahelyünkön a vezetők támogatóak.",
        description:
            "A vezetői támogatás magában foglalhat gyakorlati segítséget, tanácsot, útmutatást, valamint a munkahelyi nehézségek megbeszélését.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalóknak elegendő idejük van a munkafeladataik elvégzésére.",
        description:
            "A megfelelő munkakövetelmények azt jelentik, hogy elegendő idő áll rendelkezésre a feladatok elvégzésére, folyamatosan túlzott munkaterhelés, túl szoros határidők, összetett feladatok, magas érzelmi megterhelés vagy intenzív szellemi követelmények nélkül.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók nincsenek kitéve érzelmileg megterhelő helyzeteknek.",
        description:
            "Az érzelmileg megterhelő helyzetek olyan stresszes interakciók, mint például az ügyfelekkel történő konfliktuskezelés, vagy amikor folyamatosan olyan érzelmeket kell mutatni, amelyek nem felelnek meg a valós érzéseknek.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók befolyásolni tudják, hogyan végzik el munkafeladataikat.",
        description:
            "A munkakontroll azt jelenti, hogy a munkavállalóknak van ráhatásuk a feladatok ütemére és a feladatvégzés módjára.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók nem emelnek rendszeresen 5 kg-ot meghaladó súlyokat a feladataik részeként.",
        description:
            "Szeretnénk, ha felmérné, hogy (néhány) munkavállalónak a munkahelyén rendszeresen kell-e 5 kg-nál nehezebb súlyokat emelnie a feladatok során. A rendszeresen alatt óránként többszöri előfordulást értünk.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalóknak gyakran előre kell hajolniuk vagy csavarniuk a felsőtestüket munkafeladataik során.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló rendszeresen kényelmetlen testtartást vesz-e fel a munkahelyén. A rendszeresen alatt többet értünk napi 4 munkaóránál.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók a munkaidő jelentős részében autót vagy más járművet vezetnek.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló ki van-e téve a teljes testet érintő vibrációnak a munkája során. A teljes testet érintő vibráción azt értjük, hogy legalább napi 4 munkaórát töltenek autó vagy teherautó vezetésével, vagy különféle járművek (például földmunkagépek) üzemeltetésével.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question: "A munkahelyünkön dolgozó munkavállalók hosszú ideig ülnek a munkanap során.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló napi több mint 4 órát tölt-e ülve.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalóknak gyakran kell a vállaik fölé emelt karral dolgozniuk.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló több mint napi 4 órát dolgozik-e vállmagasság felett tartott kezekkel.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön végzett feladatok megkövetelik, hogy a munkavállalók jelentős erőt fejtsenek ki kézzel és karral.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállalónak a munkahelyén szüksége van-e olyan erőkifejtésre, amely 5 kg emelésének felel meg, napi több mint 2 munkaórában.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók olyan feladatokat végeznek, amelyek percenként többször ismétlődő kéz- vagy karmozgást igényelnek.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló a munkahelyén ugyanazt a mozdulatot végzi-e nagyon kevés vagy semmilyen változtatással, néhány másodpercenként, napi több mint 2 munkaórán át.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    },
    {
        question:
            "A munkahelyünkön dolgozó munkavállalók rezgő kézi szerszámokat használnak rendszeres munkahelyi tevékenységeik részeként.",
        description:
            "Szeretnénk felmérni, hogy (néhány) munkavállaló a munkahelyén napi több mint 2 órán át használ-e rezgő kézi szerszámokat.",
        options: [
            { label: "Teljes mértékben egyetértek", value: 5 },
            { label: "Egyetértek", value: 4 },
            { label: "Nem értek egyet és nem is ellenzem", value: 3 },
            { label: "Nem értek egyet", value: 2 },
            { label: "Egyáltalán nem értek egyet", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 3. ESPANHOL (Spain/Latin America) - es
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_ES = [
    {
        question: "Los empleados en nuestro lugar de trabajo no están expuestos al acoso.",
        description:
            "El acoso ocurre cuando una persona, repetidamente y durante un período prolongado, es sometida a un trato desagradable o degradante. Para que se produzca el acoso, la persona acosada debe tener dificultades para defenderse. El acoso puede ser verbal, psicológico, social o físico, y está destinado a intimidar, degradar o socavar.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo no están expuestos a violencia ni amenazas.",
        description:
            "La violencia en el lugar de trabajo se refiere a cualquier acto de agresión física, abuso verbal, hostigamiento o intimidación que cause daño. Las amenazas en el lugar de trabajo incluyen cualquier declaración, comportamiento o acción — explícita o implícita — que sugiera la intención de causar daño.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question: "Los empleados en nuestro lugar de trabajo son reconocidos y valorados.",
        description:
            "Las recompensas en el lugar de trabajo se refieren a la percepción del empleado de que la compensación, el reconocimiento o los beneficios que recibe coinciden con sus esfuerzos, contribuciones o expectativas.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question: "Los empleados en nuestro lugar de trabajo son tratados de forma justa.",
        description:
            "La equidad en el lugar de trabajo se refiere a un trato justo y respetuoso por parte de los supervisores y colegas.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los procesos de toma de decisiones en nuestro lugar de trabajo suelen involucrar a aquellos que se verán afectados.",
        description:
            "Los procesos de toma de decisiones justos significan que el proceso incluye e involucra a los empleados que se verán afectados.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question: "Los empleados en nuestro lugar de trabajo se apoyan mutuamente.",
        description:
            "El apoyo de los colegas puede incluir ayuda práctica y emocional, consejos y orientación.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question: "Los supervisores en nuestro lugar de trabajo son de apoyo.",
        description:
            "El apoyo del supervisor puede consistir en ayuda práctica, consejos y orientación, así como hablar sobre dificultades en el trabajo.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo tienen tiempo suficiente para completar sus tareas.",
        description:
            "Las exigencias laborales adecuadas se refieren a tener suficiente tiempo para completar las tareas de trabajo sin una carga de trabajo constantemente excesiva, plazos muy ajustados, tareas complejas, alta tensión emocional o demandas cognitivas intensas.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo no están expuestos a situaciones emocionalmente exigentes.",
        description:
            "Las situaciones emocionalmente exigentes se refieren a interacciones estresantes, como manejar conflictos con clientes o usuarios, o mostrar constantemente emociones que pueden no coincidir con los sentimientos reales en el lugar de trabajo.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo pueden influir en cómo llevan a cabo sus tareas.",
        description:
            "El control del trabajo se refiere a la influencia sobre las tareas, como el ritmo y la forma de ejecutar las funciones.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo no levantan regularmente pesos que superen los 5 kg como parte de sus tareas.",
        description:
            "Nos gustaría que evalúe si (algunos) empleados en su lugar de trabajo necesitan levantar regularmente pesos superiores a 5 kg como parte de sus tareas. Por regularmente, nos referimos a varias veces por hora.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo con frecuencia deben inclinarse hacia adelante o girar la parte superior del cuerpo durante sus tareas.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo adoptan posturas incómodas con regularidad. Por regularidad, nos referimos a más de 4 horas por jornada laboral.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo conducen un coche o vehículo durante una parte significativa de la jornada laboral.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo están expuestos a vibraciones de todo el cuerpo durante su trabajo regular. Por exposición a vibraciones de todo el cuerpo, nos referimos a al menos 4 horas por día de trabajo conduciendo coches o camiones, u operando vehículos, como maquinaria de movimiento de tierras.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo permanecen sentados durante períodos prolongados a lo largo de la jornada laboral.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo pasan más de 4 horas sentados por jornada laboral.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo deben trabajar con los brazos por encima de la altura de los hombros con frecuencia.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo pasan más de 4 horas trabajando con las manos por encima de la altura de los hombros.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Las tareas en nuestro lugar de trabajo implican que los empleados apliquen una fuerza significativa con sus manos y brazos.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo necesitan ejercer una fuerza equivalente a levantar 5 kg durante más de 2 horas por jornada laboral.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo realizan tareas que requieren movimientos repetitivos de manos o brazos muchas veces por minuto.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo repiten el mismo movimiento con poca o ninguna variación cada pocos segundos, durante más de 2 horas por jornada laboral.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    },
    {
        question:
            "Los empleados en nuestro lugar de trabajo utilizan herramientas manuales vibradoras como parte de sus actividades laborales regulares.",
        description:
            "Nos gustaría evaluar si (algunos) empleados en su lugar de trabajo utilizan herramientas manuales vibradoras durante más de 2 horas por jornada laboral.",
        options: [
            { label: "Totalmente de acuerdo", value: 5 },
            { label: "De acuerdo", value: 4 },
            { label: "Ni de acuerdo ni en desacuerdo", value: 3 },
            { label: "En desacuerdo", value: 2 },
            { label: "Totalmente en desacuerdo", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 4. ALEMÃO (Germany) - de
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_DE = [
    {
        question: "Die Beschäftigten an unserem Arbeitsplatz sind keinem Mobbing ausgesetzt.",
        description:
            "Mobbing findet statt, wenn eine Person wiederholt und über einen längeren Zeitraum unangenehmen oder herabwürdigenden Handlungen ausgesetzt ist. Damit Mobbing vorliegt, muss es der betroffenen Person schwerfallen, sich zu verteidigen. Mobbing kann verbal, psychisch, sozial oder physisch erfolgen und zielt darauf ab, einzuschüchtern, herabzusetzen oder zu untergraben.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz sind weder Gewalt noch Drohungen ausgesetzt.",
        description:
            "Arbeitsplatzgewalt bezieht sich auf jede Form von physischer Aggression, verbalen Missbrauch, Belästigung oder Einschüchterung, die Schaden verursacht. Drohungen am Arbeitsplatz umfassen jede Aussage, jedes Verhalten oder jede Handlung – ausdrücklich oder implizit –, die die Absicht nahelegt, Schaden zuzufügen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question: "Die Beschäftigten an unserem Arbeitsplatz werden anerkannt und wertgeschätzt.",
        description:
            "Belohnungen am Arbeitsplatz beziehen sich auf die Wahrnehmung der Beschäftigten, dass die Vergütung, Anerkennung oder Leistungen, die sie erhalten, ihren Bemühungen, Beiträgen oder Erwartungen entsprechen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question: "Die Beschäftigten an unserem Arbeitsplatz werden fair behandelt.",
        description:
            "Gerechtigkeit am Arbeitsplatz bedeutet eine faire und respektvolle Behandlung durch Vorgesetzte und Kolleginnen/Kollegen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Entscheidungsprozesse an unserem Arbeitsplatz beziehen normalerweise diejenigen ein, die davon betroffen sind.",
        description:
            "Faire Entscheidungsprozesse bedeuten, dass die Beschäftigten, die davon betroffen sind, in den Prozess einbezogen werden.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question: "Die Beschäftigten an unserem Arbeitsplatz unterstützen sich gegenseitig.",
        description:
            "Unterstützung durch Kolleginnen/Kollegen kann praktische und emotionale Hilfe, Ratschläge und Anleitung umfassen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question: "Die Vorgesetzten an unserem Arbeitsplatz sind unterstützend.",
        description:
            "Unterstützung durch Vorgesetzte kann praktische Hilfe, Ratschläge und Anleitung beinhalten sowie das gemeinsame Besprechen von Schwierigkeiten am Arbeitsplatz.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz haben ausreichend Zeit, um ihre Arbeitsaufgaben zu erledigen.",
        description:
            "Angemessene Arbeitsanforderungen bedeuten, dass genügend Zeit zur Verfügung steht, um die Aufgaben zu erledigen, ohne dauerhaft übermäßige Arbeitsbelastung, sehr enge Fristen, komplexe Aufgaben, hohe emotionale Belastung oder intensive kognitive Anforderungen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz sind keinen emotional anspruchsvollen Situationen ausgesetzt.",
        description:
            "Emotional anspruchsvolle Situationen beziehen sich auf stressige Interaktionen, wie zum Beispiel Konflikte mit Kunden zu bewältigen, oder das ständige Zeigen von Emotionen, die nicht den tatsächlichen Gefühlen entsprechen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz können beeinflussen, wie sie ihre Arbeitsaufgaben ausführen.",
        description:
            "Arbeitskontrolle bedeutet, Einfluss auf die Arbeitsaufgaben zu haben, etwa auf das Tempo und die Art und Weise der Aufgabenerledigung.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz heben im Rahmen ihrer Aufgaben nicht regelmäßig Gewichte über 5 kg.",
        description:
            "Bitte bewerten Sie, ob (einige) Beschäftigte an Ihrem Arbeitsplatz regelmäßig Gewichte über 5 kg im Rahmen ihrer Aufgaben heben müssen. Mit regelmäßig meinen wir mehrmals pro Stunde.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz müssen bei ihren Aufgaben häufig den Oberkörper nach vorn beugen oder verdrehen.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz regelmäßig unergonomische Haltungen einnehmen. Mit regelmäßig meinen wir mehr als 4 Stunden pro Arbeitstag.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz fahren einen PKW oder ein anderes Fahrzeug während eines erheblichen Teils des Arbeitstages.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz Ganzkörpervibrationen während ihrer regulären Arbeit ausgesetzt sind. Mit Ganzkörpervibration meinen wir mindestens 4 Stunden pro Arbeitstag beim Fahren von PKWs oder LKWs oder beim Bedienen von Fahrzeugen wie Erdbewegungsmaschinen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz sitzen während ihres regulären Arbeitstages über längere Zeiträume.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz mehr als 4 Stunden pro Arbeitstag sitzen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz müssen häufig mit den Armen über Schulterhöhe arbeiten.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz mehr als 4 Stunden lang mit den Händen über Schulterhöhe arbeiten.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Aufgaben an unserem Arbeitsplatz beinhalten, dass Beschäftigte erhebliche Kraft mit ihren Händen und Armen aufwenden.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz Kraft aufwenden müssen, die dem Heben von 5 kg entspricht, und das über mehr als 2 Stunden pro Arbeitstag.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz führen Tätigkeiten aus, die repetitive Bewegungen der Hände oder Arme mehrfach pro Minute erfordern.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz dieselbe Bewegung mit wenig oder keiner Variation alle paar Sekunden für mehr als 2 Stunden pro Arbeitstag ausführen.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    },
    {
        question:
            "Die Beschäftigten an unserem Arbeitsplatz nutzen vibrierende Handwerkzeuge als Teil ihrer regulären Arbeit.",
        description:
            "Wir möchten beurteilen, ob (einige) Beschäftigte an Ihrem Arbeitsplatz vibrierende Handwerkzeuge über mehr als 2 Stunden pro Arbeitstag verwenden.",
        options: [
            { label: "Stimme vollkommen zu", value: 5 },
            { label: "Stimme zu", value: 4 },
            { label: "Weder Zustimmung noch Ablehnung", value: 3 },
            { label: "Lehne ab", value: 2 },
            { label: "Lehne vollkommen ab", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 5. TURCO (Turkey) - tr
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_TR = [
    {
        question: "İşyeri çalışanlarımız zorbalığa maruz kalmamaktadır.",
        description:
            "Zorbalık, bir kişinin tekrar tekrar ve uzun bir süre boyunca rahatsız edici veya aşağılayıcı muameleye maruz kalmasıdır. Zorbalığın gerçekleşmesi için, zorbalığa uğrayan kişinin kendini savunmakta zorlanması gerekir. Zorbalık sözlü, psikolojik, sosyal veya fiziksel olabilir ve korkutmak, küçümsemek veya zayıflatmak amacı taşır.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız şiddete veya tehditlere maruz kalmamaktadır.",
        description:
            "İşyerinde şiddet, fiziksel saldırı, sözlü taciz, taciz veya korkutma gibi zarar verici herhangi bir eylemi ifade eder. İşyerinde tehdit, açık veya örtülü olarak zarar verme niyetini ima eden her türlü ifade, davranış veya eylemi içerir.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız tanınmakta ve değer görmektedir.",
        description:
            "İşyerindeki ödüllendirme, çalışanların aldıkları ücret, takdir veya faydaların; çaba, katkı veya beklentileriyle uyumlu olduğu algısını ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız adil şekilde muamele görmektedir.",
        description:
            "İşyerinde adalet, yöneticiler ve çalışma arkadaşları tarafından adil ve saygılı bir tutum sergilenmesini ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyerimizdeki karar alma süreçlerine genellikle etkilenecek olan kişiler dahil edilir.",
        description:
            "Adil karar alma süreçleri, karardan etkilenen çalışanların sürece dahil edilmesini ve süreçte yer almalarını ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız birbirlerini destekler.",
        description:
            "Çalışma arkadaşlarının desteği; pratik ve duygusal yardım, tavsiye ve rehberlik gibi unsurları içerebilir.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyerimizdeki yöneticiler destekleyicidir.",
        description:
            "Yönetici desteği; pratik yardım, tavsiye ve rehberlik sunmanın yanı sıra işyerindeki zorlukları birlikte ele almayı da içerir.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız iş görevlerini tamamlamak için yeterli zamana sahiptir.",
        description:
            "Uygun iş talepleri, sürekli aşırı iş yükü, çok sıkı son teslim tarihleri, karmaşık görevler, yüksek duygusal yük veya yoğun bilişsel gereksinimler olmaksızın görevleri tamamlamak için yeterli zamana sahip olmayı ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız duygusal açıdan zorlayıcı durumlara maruz kalmamaktadır.",
        description:
            "Duygusal açıdan zorlayıcı durumlar, müşterilerle veya kullanıcılarla çatışma yönetimi gibi stresli etkileşimleri veya işyerinde gerçek duygularla uyuşmayan duyguları sürekli göstermeyi gerektiren durumları ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımız, iş görevlerini nasıl yerine getirecekleri konusunda etki sahibidir.",
        description:
            "İş kontrolü, işin hızı ve görevlerin nasıl yerine getirileceği gibi konularda söz sahibi olmayı ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımız görevleri kapsamında düzenli olarak 5 kg'dan ağır yükler kaldırmamaktadır.",
        description:
            "Lütfen işyerinizdeki (bazı) çalışanların görevlerinin bir parçası olarak düzenli olarak 5 kg'dan ağır yükler kaldırması gerekip gerekmediğini değerlendirin. Düzenli olarak ifadesiyle, saat başına birkaç kez gerçekleşmeyi kastediyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımızdan, iş görevleri sırasında sık sık öne eğilmeleri veya üst bedenlerini bükmeleri istenmektedir.",
        description:
            "İşyerinizdeki (bazı) çalışanların düzenli olarak rahatsız edici duruşlar sergileyip sergilemediğini değerlendirmek istiyoruz. Düzenli olarak ifadesiyle, iş gününde 4 saatten fazla süreyi kastediyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımız, iş gününün önemli bir bölümünde araba veya araç kullanmaktadır.",
        description:
            "İşyerinizdeki (bazı) çalışanların düzenli işleri sırasında tüm vücudu etkileyen titreşimlere maruz kalıp kalmadığını değerlendirmek istiyoruz. Tüm vücudu etkileyen titreşim, araba veya kamyon kullanarak ya da toprak işleme makineleri gibi araçları çalıştırarak günde en az 4 saat geçirmeyi ifade eder.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question: "İşyeri çalışanlarımız, normal iş günleri boyunca uzun süreler oturmaktadır.",
        description:
            "İşyerinizdeki (bazı) çalışanların iş günü başına 4 saatten fazla oturarak zaman geçirip geçirmediğini değerlendirmek istiyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımızın, kollarını omuz hizasından yukarıda tutarak sık sık çalışması gerekmektedir.",
        description:
            "İşyerinizdeki (bazı) çalışanların ellerini omuz hizasından yukarıda tutarak günde 4 saatten fazla çalışıp çalışmadığını değerlendirmek istiyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri görevlerimiz, çalışanların elleri ve kolları ile önemli miktarda güç uygulamasını gerektirir.",
        description:
            "İşyerinizdeki (bazı) çalışanların, 5 kg kaldırmaya eşdeğer bir güç uygulamaları gerekip gerekmediğini ve bunu iş günü başına 2 saatten fazla yapıp yapmadıklarını değerlendirmek istiyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımız, dakikada birçok kez ellerini veya kollarını tekrarlayan hareketler gerektiren görevleri yerine getirir.",
        description:
            "İşyerinizdeki (bazı) çalışanların, birkaç saniyede bir aynı hareketi çok az veya hiç değişiklik olmaksızın, günde 2 saatten fazla süreyle yapıp yapmadıklarını değerlendirmek istiyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    },
    {
        question:
            "İşyeri çalışanlarımız, düzenli iş faaliyetlerinin bir parçası olarak titreşimli el aletleri kullanır.",
        description:
            "İşyerinizdeki (bazı) çalışanların, iş günü başına 2 saatten fazla titreşimli el aletleri kullanıp kullanmadığını değerlendirmek istiyoruz.",
        options: [
            { label: "Tamamen katılıyorum", value: 5 },
            { label: "Katılıyorum", value: 4 },
            { label: "Ne katılıyorum ne de katılmıyorum", value: 3 },
            { label: "Katılmıyorum", value: 2 },
            { label: "Kesinlikle katılmıyorum", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 6. HOLANDÊS (Netherlands) - nl
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_NL = [
    {
        question: "Werknemers op onze werkplek worden niet blootgesteld aan pesterijen.",
        description:
            "Pesten vindt plaats wanneer een persoon herhaaldelijk en gedurende een langere periode wordt blootgesteld aan onaangename of vernederende behandeling. Opdat er sprake is van pesten, moet het voor de gepeste persoon moeilijk zijn zich te verdedigen. Pesten kan verbaal, psychologisch, sociaal of fysiek zijn en is bedoeld om te intimideren, te vernederen of te ondermijnen.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek worden niet blootgesteld aan geweld of bedreigingen.",
        description:
            "Geweld op de werkplek verwijst naar elke vorm van fysieke agressie, verbaal misbruik, intimidatie of bedreiging die schade veroorzaakt. Bedreigingen op de werkplek omvatten elke verklaring, elk gedrag of elke handeling – expliciet of impliciet – die duidt op de intentie om schade toe te brengen.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question: "Werknemers op onze werkplek worden erkend en gewaardeerd.",
        description:
            "Beloningen op de werkplek verwijzen naar de perceptie van de werknemer dat de vergoeding, erkenning of voordelen die hij/zij ontvangt, overeenkomen met de inspanningen, bijdragen of verwachtingen.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question: "Werknemers op onze werkplek worden rechtvaardig behandeld.",
        description:
            "Rechtvaardigheid op de werkplek verwijst naar een eerlijke en respectvolle behandeling door leidinggevenden en collega's.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "De besluitvormingsprocessen op onze werkplek betrekken gewoonlijk degenen die erdoor worden beïnvloed.",
        description:
            "Eerlijke besluitvormingsprocessen betekenen dat de werknemers die worden beïnvloed, in het proces worden betrokken.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question: "Werknemers op onze werkplek steunen elkaar.",
        description:
            "Ondersteuning door collega's kan praktische en emotionele hulp, advies en begeleiding omvatten.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question: "Leidinggevenden op onze werkplek bieden steun.",
        description:
            "Ondersteuning door leidinggevenden kan bestaan uit praktische hulp, advies en begeleiding, evenals het bespreken van moeilijkheden op het werk.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question: "Werknemers op onze werkplek hebben voldoende tijd om hun taken af te ronden.",
        description:
            "Geschikte werkeisen betekent dat er genoeg tijd is om taken af te ronden zonder voortdurend overmatige werkdruk, strakke deadlines, complexe taken, hoge emotionele belasting of intense cognitieve eisen.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek worden niet blootgesteld aan emotioneel veeleisende situaties.",
        description:
            "Emotioneel veeleisende situaties verwijzen naar stressvolle interacties, zoals het omgaan met conflicten met klanten, of het constant tonen van emoties die niet overeenkomen met wat iemand werkelijk voelt op de werkplek.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek kunnen invloed uitoefenen op de manier waarop zij hun taken uitvoeren.",
        description:
            "Taakcontrole verwijst naar invloed op de werktaken, zoals het werktempo en hoe de taken worden uitgevoerd.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek tillen niet regelmatig gewichten van meer dan 5 kg als onderdeel van hun taken.",
        description:
            "We willen graag dat u beoordeelt of (sommige) werknemers op uw werkplek regelmatig gewichten van meer dan 5 kg moeten tillen als onderdeel van hun taken. Met regelmatig bedoelen we meerdere keren per uur.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek moeten tijdens hun taken regelmatig voorover buigen of hun bovenlichaam draaien.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek regelmatig ongemakkelijke houdingen aannemen. Met regelmatig bedoelen we meer dan 4 uur per werkdag.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek besturen een auto of een ander voertuig gedurende een aanzienlijk deel van de werkdag.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek worden blootgesteld aan trillingen van het hele lichaam tijdens hun reguliere werk. Met blootstelling aan trillingen van het hele lichaam bedoelen we minstens 4 uur per werkdag bij het besturen van auto's of vrachtwagens, of het bedienen van voertuigen zoals grondverzetmachines.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek zitten gedurende langere periodes tijdens hun normale werkdag.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek meer dan 4 uur per werkdag zittend doorbrengen.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek moeten regelmatig met de armen boven schouderhoogte werken.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek meer dan 4 uur werken met de handen boven schouderhoogte.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Taken op onze werkplek vereisen dat werknemers aanzienlijke kracht met hun handen en armen uitoefenen.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek kracht moeten uitoefenen die gelijkstaat aan het tillen van 5 kg, gedurende meer dan 2 uur per werkdag.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek voeren taken uit die repetitieve bewegingen van hun handen of armen meerdere keren per minuut vereisen.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek dezelfde beweging met weinig of geen variatie elke paar seconden uitvoeren, gedurende meer dan 2 uur per werkdag.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    },
    {
        question:
            "Werknemers op onze werkplek gebruiken vibrerende handgereedschappen als onderdeel van hun reguliere werkzaamheden.",
        description:
            "We willen graag beoordelen of (sommige) werknemers op uw werkplek meer dan 2 uur per werkdag vibrerend handgereedschap gebruiken.",
        options: [
            { label: "Helemaal mee eens", value: 5 },
            { label: "Mee eens", value: 4 },
            { label: "Niet mee eens, niet mee oneens", value: 3 },
            { label: "Oneens", value: 2 },
            { label: "Helemaal mee oneens", value: 1 }
        ]
    }
];

////////////////////////////////////////////////////////////////////////////////
// 7. DINAMARQUÊS (Denmark) - da
////////////////////////////////////////////////////////////////////////////////
export const dssQuestions_DA = [
    {
        question: "Medarbejdere på vores arbejdsplads er ikke udsat for mobning.",
        description:
            "Mobning forekommer, når en person gentagne gange og over en længere periode udsættes for ubehagelig eller nedværdigende behandling. For at der kan være tale om mobning, skal den, der udsættes, have svært ved at forsvare sig. Mobning kan være verbal, psykologisk, social eller fysisk og har til formål at intimidere, nedgøre eller underminere.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question: "Medarbejdere på vores arbejdsplads er ikke udsat for vold eller trusler.",
        description:
            "Vold på arbejdspladsen henviser til enhver form for fysisk aggression, verbale overgreb, chikane eller intimidering, der forårsager skade. Trusler på arbejdspladsen omfatter enhver erklæring, adfærd eller handling – eksplicit eller underforstået – der antyder en hensigt om at forårsage skade.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question: "Medarbejdere på vores arbejdsplads bliver anerkendt og værdsat.",
        description:
            "Belønninger på arbejdspladsen henviser til medarbejderens opfattelse af, at den løn, anerkendelse eller de fordele, de modtager, stemmer overens med deres indsats, bidrag eller forventninger.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question: "Medarbejdere på vores arbejdsplads behandles retfærdigt.",
        description:
            "Retfærdighed på arbejdspladsen henviser til en retfærdig og respektfuld behandling fra ledere og kolleger.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Beslutningsprocesserne på vores arbejdsplads involverer normalt dem, der bliver berørt.",
        description:
            "Retfærdige beslutningsprocesser betyder, at de medarbejdere, som bliver berørt, inkluderes og inddrages i processen.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question: "Medarbejdere på vores arbejdsplads støtter hinanden.",
        description:
            "Støtte fra kolleger kan omfatte praktisk og følelsesmæssig hjælp, rådgivning og vejledning.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question: "Ledere på vores arbejdsplads er støttende.",
        description:
            "Støtte fra en leder kan være praktisk hjælp, rådgivning og vejledning samt at tale om vanskeligheder på arbejdet.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads har tid nok til at udføre deres arbejdsopgaver.",
        description:
            "Passende arbejdskrav betyder, at der er nok tid til at udføre arbejdsopgaverne uden vedvarende overdrevet arbejdsbyrde, stramme deadlines, komplekse opgaver, højt følelsesmæssigt pres eller intensive kognitive krav.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads er ikke udsat for følelsesmæssigt krævende situationer.",
        description:
            "Følelsesmæssigt krævende situationer henviser til stressende interaktioner, såsom at håndtere konflikter med kunder, eller løbende at skulle udvise følelser, der måske ikke stemmer overens med ens reelle følelser på arbejdspladsen.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads kan påvirke, hvordan de udfører deres arbejdsopgaver.",
        description:
            "Jobkontrol henviser til indflydelse på arbejdsopgaverne, såsom tempo, og hvordan opgaverne udføres.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads løfter ikke regelmæssigt vægte over 5 kg som en del af deres opgaver.",
        description:
            "Vi vil gerne have dig til at vurdere, om (nogle) medarbejdere på din arbejdsplads regelmæssigt skal løfte vægte over 5 kg som en del af deres opgaver. Med regelmæssigt mener vi flere gange i timen.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads skal ofte bøje sig forover eller vride overkroppen under deres arbejdsopgaver.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads regelmæssigt indtager uhensigtsmæssige arbejdsstillinger. Med regelmæssigt mener vi mere end 4 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads kører bil eller et andet køretøj i en væsentlig del af arbejdsdagen.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads udsættes for helkropsvibrationer under deres almindelige arbejde. Ved helkropsvibrationer mener vi mindst 4 timer pr. arbejdsdag ved kørsel af biler eller lastbiler eller betjening af køretøjer såsom jordflytningsmaskiner.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads sidder i længere perioder i løbet af deres normale arbejdsdag.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads sidder ned i mere end 4 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads skal ofte arbejde med armene over skulderhøjde.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads arbejder med hænderne over skulderhøjde i mere end 4 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Opgaverne på vores arbejdsplads indebærer, at medarbejdere anvender betydelig kraft med hænder og arme.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads skal udøve en kraft, der svarer til at løfte 5 kg, i mere end 2 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads udfører opgaver, der kræver gentagne bevægelser af hænder eller arme mange gange i minuttet.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads udfører den samme bevægelse med lidt eller ingen variation hvert par sekunder i mere end 2 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    },
    {
        question:
            "Medarbejdere på vores arbejdsplads bruger vibrerende håndværktøj som en del af deres regelmæssige arbejdsopgaver.",
        description:
            "Vi vil gerne vurdere, om (nogle) medarbejdere på din arbejdsplads bruger vibrerende håndværktøj i mere end 2 timer pr. arbejdsdag.",
        options: [
            { label: "Meget enig", value: 5 },
            { label: "Enig", value: 4 },
            { label: "Hverken enig eller uenig", value: 3 },
            { label: "Uenig", value: 2 },
            { label: "Meget uenig", value: 1 }
        ]
    }
];
